import { EmailSenderFormData } from '@/features/dashboard/emailSender/schemas/emailSenderSchema.ts';
import {
  EmailSenderSettingsDto,
  UpdateEmailSenderSettingsRequest,
} from '@/features/dashboard/emailSender/types/EmailSenderSettingsDto.ts';

const emptyToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

export const emailSenderSettingsMapper = {
  fromDtoToForm(dto: EmailSenderSettingsDto): EmailSenderFormData {
    return {
      fromEmail: dto.fromEmail ?? '',
      fromName: dto.fromName ?? '',
      replyToEmail: dto.replyToEmail ?? '',
    };
  },
  fromFormToDto(form: EmailSenderFormData): UpdateEmailSenderSettingsRequest {
    return {
      fromEmail: emptyToNull(form.fromEmail),
      fromName: emptyToNull(form.fromName),
      replyToEmail: emptyToNull(form.replyToEmail),
    };
  },
};
